import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
  })
  export class StepTrackerService {
    private currentStepSubject = new BehaviorSubject<string>("0");
    private currentEventNameSubject = new BehaviorSubject<string>('');
    currentStep$ = this.currentStepSubject.asObservable();
    currentEventName$ = this.currentEventNameSubject.asObservable();
  
    updateStep(step: string) {
      this.currentStepSubject.next(step);
    }
  
    getCurrentStep(): string {
      return this.currentStepSubject.getValue();
    }

    updateNameEvent(eventName: string) {
      this.currentEventNameSubject.next(eventName);
    }

    getCurrentEventName(): string {
      return this.currentEventNameSubject.getValue();
    }
  }